/**
 * @file: DecisionChip.tsx
 * @copyright: (c) 2019-2021 sichuan zhichetech co., ltd.
 *
 * The customer's per-item decision, encoded by color: confirmed work reads
 * green, declined recedes to neutral, and an undecided item still in play
 * glows amber to flag that it needs a follow-up call.
 */

import { Typography } from '@euler/app/components/typography';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import {
  LeadItemDecision,
  LeadItemDecisionLabel,
} from '@euler/model/lead/LeadItem';
import { View } from 'react-native';
import { LD } from '../leadDetailKit';

export const DecisionChip = ({
  decision,
  terminal,
}: {
  decision: LeadItemDecision | null | undefined;
  terminal: boolean;
}) => {
  const { rpx } = useResponsiveContext();
  const { bg, fg } =
    decision === 'will_fix'
      ? { bg: LD.successSoft, fg: LD.success }
      : decision === 'declined'
      ? { bg: LD.hairline, fg: LD.steel }
      : terminal
      ? { bg: 'transparent', fg: LD.mist }
      : { bg: LD.amberSoft, fg: LD.amber };
  return (
    <View
      style={{
        backgroundColor: bg,
        borderRadius: rpx(11),
        paddingHorizontal: rpx(10),
        paddingVertical: rpx(4),
      }}
    >
      <Typography.Text size={rpx(12)} color={fg} medium>
        {decision ? LeadItemDecisionLabel[decision] : '待确认'}
      </Typography.Text>
    </View>
  );
};
